import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Services } from '../../shared/literals/shared.literal';

import { MiscellaneousItemListComponent } from './miscellaneous-item-list/miscellaneous-item-list.component';
import { CheckOutMiscellaneousItemComponent } from './check-out-miscellaneous-item/check-out-miscellaneous-item.component';

const routes: Routes = [
  {
    path: '',
    component: MiscellaneousItemListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateUpdateMiscellaneousItems, Services.ShippingMethodRequired))]
  },
  {
    path: 'BoxesLabel/CheckOutMiscellaneousItem/:id',
    component: CheckOutMiscellaneousItemComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateUpdateMiscellaneousItems, Services.ShippingMethodRequired))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class MiscellaneousItemsRoutingModule {

}
